import Resources from '@/Resources';
import Config from '@/Config';
import { help, helpAdmin, blog } from '@Data/HelpUrls.js';

const accentLink = (text, url = '#') => `<a href="${url}" target="_blank" rel="noopener noreferrer" class="gfu-link gfu-link--accent _tdu">${text}</a>`;

export function getStatistics() {
    return [
        {
            title: Resources.PledgeManager.StatisticTitle1,
            value: Resources.PledgeManager.StatisticValue1,
        },
        {
            title: Resources.PledgeManager.StatisticTitle2,
            value: Resources.PledgeManager.StatisticValue2,
            linkText: Resources.PledgeManager.StatisticLinkText2,
            linkUrl: help.paymentMethods,
        },
        {
            title: Resources.PledgeManager.StatisticTitle3,
            value: Resources.PledgeManager.StatisticValue3,
            linkText: Resources.PledgeManager.StatisticLinkText3,
            linkUrl: helpAdmin.howToSetUpStretchPay,
        },
        {
            title: Resources.PledgeManager.StatisticTitle4,
            value: Resources.PledgeManager.StatisticValue4,
            linkText: Resources.PledgeManager.StatisticLinkText4,
            linkUrl: Config.navigation.feesUrl,
        },
    ];
}

export function getIntroductionStages() {
    return [
        {
            header: Resources.PledgeManager.Introduction1Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Introduction1Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Introduction1Paragraph2,
                },
                {
                    text: Resources.PledgeManager.Introduction1Paragraph3,
                }],
        },
        {
            header: Resources.PledgeManager.Introduction2Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Introduction2Paragraph1,
                    links: [
                        {
                            url: blog.expressCrowdfunding,
                            text: Resources.PledgeManager.Introduction2LinkText1,
                        },
                        {
                            url: helpAdmin.expressCrowdfunding,
                            text: Resources.PledgeManager.Introduction2LinkText2,
                        },
                    ],
                },
            ],
        },
        {
            header: Resources.PledgeManager.Introduction3Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Introduction3Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Introduction3Paragraph2,
                },
                {
                    text: Resources.PledgeManager.Introduction3Paragraph3,
                },
                {
                    text: Resources.PledgeManager.Introduction3Paragraph4,
                    links: [
                        {
                            text: Resources.PledgeManager.Introduction3LinkText4,
                            url: Config.navigation.marketingServicesUrl,
                        },
                    ],
                },
                {
                    text: Resources.PledgeManager.Introduction3Paragraph5,
                },
            ],
        },
    ];
}

export function getExplanationSections() {
    return [
        {
            icon: 'rectangles-mixed',
            header: Resources.PledgeManager.Explanation1Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation1Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Explanation1Paragraph2,
                },
            ],
        },
        {
            icon: 'users',
            header: Resources.PledgeManager.Explanation2Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation2Paragraph1,
                    list: [
                        Resources.PledgeManager.Explanation2ListItem1,
                        Resources.PledgeManager.Explanation2ListItem2,
                        Resources.PledgeManager.Explanation2ListItem3,
                        Resources.PledgeManager.Explanation2ListItem4,
                        Resources.PledgeManager.Explanation2ListItem5,
                    ],
                },
                {
                    text: Resources.PledgeManager.Explanation2Paragraph2,
                },
                {
                    text: Resources.PledgeManager.Explanation2Paragraph3,
                },
            ],
        },
        {
            icon: 'display-chart-up',
            header: Resources.PledgeManager.Explanation3Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation3Paragraph1,
                    links: [
                        {
                            text: Resources.PledgeManager.Explanation3LinkText1,
                            url: helpAdmin.usersManageUsers,
                        },
                    ],
                },
                {
                    text: Resources.PledgeManager.Explanation3Paragraph2,
                },
                {
                    text: Resources.PledgeManager.Explanation3Paragraph3,
                },
            ],
        },
        {
            icon: 'clock',
            header: Resources.PledgeManager.Explanation4Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation4Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Explanation4Paragraph2,
                },
            ],
        },
        {
            icon: 'trophy',
            header: Resources.PledgeManager.Explanation5Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation5Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Explanation5Paragraph2,
                },
            ],
        },
        {
            icon: 'lightbulb',
            header: Resources.PledgeManager.Explanation6Header,
            paragraphs: [
                {
                    text: Resources.PledgeManager.Explanation6Paragraph1,
                },
                {
                    text: Resources.PledgeManager.Explanation6Paragraph2,
                },
                {
                    text: Resources.PledgeManager.Explanation6Paragraph3,
                },
            ],
        },
    ];
}

export function getValues() {
    return [
        { valueID: 'rewards', title: Resources.PledgeManager.ValueTitle1 },
        { valueID: 'shipping', title: Resources.PledgeManager.ValueTitle2 },
        { valueID: 'installments', title: Resources.PledgeManager.ValueTitle3 },
        { valueID: 'taxSetup', title: Resources.PledgeManager.ValueTitle4 },
        { valueID: 'reports', title: Resources.PledgeManager.ValueTitle5 },
        { valueID: 'marketing', title: Resources.PledgeManager.ValueTitle6 },
        { valueID: 'creatorSupport', title: Resources.PledgeManager.ValueTitle7 },
        { valueID: 'latePledges', title: Resources.PledgeManager.ValueTitle8 },
        { valueID: 'externalImports', title: Resources.PledgeManager.ValueTitle9 },
    ];
}

export function getSetupSteps() {
    return [
        {
            stepNumber: 1,
            title: Resources.PledgeManager.SetupStepTitle1,
            description: Resources.PledgeManager.SetupStepDescription1,
        },
        {
            stepNumber: 2,
            title: Resources.PledgeManager.SetupStepTitle2,
            description: Resources.PledgeManager.SetupStepDescription2,
        },
        {
            stepNumber: 3,
            title: Resources.PledgeManager.SetupStepTitle3,
            description: Resources.PledgeManager.SetupStepDescription3,
        },
    ];
}

export function getSetupStepsSummary() {
    return Resources.PledgeManager.SetupStepSummary;
}

export function getWhyUsSections() {
    return [
        {
            sectionID: 'why-us',
            header: Resources.PledgeManager.WhyUs1Header,
            paragraphs: [
                Resources.PledgeManager.WhyUs1Paragraph1,
                Resources.PledgeManager.WhyUs1Paragraph2,
                Resources.PledgeManager.WhyUs1Paragraph3,
            ],
            image: '/content/images/static/pledge-manager/user-thinking.svg',
        },
    ];
}

export function getHelpCenterLinks() {
    return [
        { label: Resources.PledgeManager.HelpCenterLinkLabel1, url: helpAdmin.whatChangedWithPlatformUpgrade },
        { label: Resources.PledgeManager.HelpCenterLinkLabel2, url: helpAdmin.pledgeManagerGettingStartedForExternalCampaigns },
        { label: Resources.PledgeManager.HelpCenterLinkLabel3, url: helpAdmin.importingPledges },
        { label: Resources.PledgeManager.HelpCenterLinkLabel4, url: helpAdmin.projectSettingsShippingAndTaxesLocations },
        { label: Resources.PledgeManager.HelpCenterLinkLabel5, url: helpAdmin.productsProductGroups },
        { label: Resources.PledgeManager.HelpCenterLinkLabel6, url: helpAdmin.usersUserGroups },
        { label: Resources.PledgeManager.HelpCenterLinkLabel7, url: helpAdmin.taxHandling },
        { label: Resources.PledgeManager.HelpCenterLinkLabel8, url: helpAdmin.pledgeManagerReminders },
        { label: Resources.PledgeManager.HelpCenterLinkLabel9, url: helpAdmin.projectSettingsOrdersPm },
        { label: Resources.PledgeManager.HelpCenterLinkLabel10, url: helpAdmin.pledgeManagerSoftCloseDate },
    ];
}

const partnerBasePath = '/content/images/static/pledge-manager/they-trusted-us';
export const partnerLogos = [
    {
        name: 'Creality',
        imageUrl: `${partnerBasePath}/logo-01.webp`,
        url: '/creators/creality',
    },
    {
        name: 'Brax',
        imageUrl: `${partnerBasePath}/logo-02.webp`,
        url: '/creators/braxtechnologies',
    },
    {
        name: 'Kineon',
        imageUrl: `${partnerBasePath}/logo-03.webp`,
        url: '/creators/kineon',
    },
    {
        name: 'Skwheel',
        imageUrl: `${partnerBasePath}/logo-04.webp`,
        url: '/creators/skwheel',
    },
    {
        name: 'Cirage Paris',
        imageUrl: `${partnerBasePath}/logo-05.webp`,
        url: '/creators/cirage-paris',
    },
    {
        name: 'absxylute',
        imageUrl: `${partnerBasePath}/logo-06.webp`,
        url: '/creators/abxylutegaming',
    },
    {
        name: 'Bluetti',
        imageUrl: `${partnerBasePath}/logo-07.webp`,
        url: '/creators/bluettiteam',
    },
];

export function getControlHighlights() {
    return [
        {
            title: Resources.PledgeManager.ControlHighlightTitle1,
            description: Resources.PledgeManager.ControlHighlightDescription1,
            url: Config.navigation.createCreatorAccountUrl,
            linkText: Resources.PledgeManager.ControlHighlightLinkText1,
        },
        {
            title: Resources.PledgeManager.ControlHighlightTitle2,
            description: Resources.PledgeManager.ControlHighlightDescription2,
        },
        {
            title: Resources.PledgeManager.ControlHighlightTitle3,
            description: Resources.PledgeManager.ControlHighlightDescription3,
        },
        {
            title: Resources.PledgeManager.ControlHighlightTitle4,
            description: Resources.PledgeManager.ControlHighlightDescription4,
        },
    ];
}

export function getComparisonRows() {
    return [
        {
            label: Resources.PledgeManager.ComparisonLabel1,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription1,
            secondary: Resources.PledgeManager.ComparisonSecondaryDescription1,
        },
        {
            label: Resources.PledgeManager.ComparisonLabel2,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription2,
            secondary: Resources.PledgeManager.ComparisonSecondaryDescription2,
        },
        {
            label: Resources.PledgeManager.ComparisonLabel3,
            primaryIcon: 'check',
            secondaryIcon: 'times',
        },
        {
            label: Resources.PledgeManager.ComparisonLabel4,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription4,
            secondaryIcon: 'times',
        },
        {
            label: Resources.PledgeManager.ComparisonLabel5,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription5,
            secondary: Resources.PledgeManager.ComparisonSecondaryDescription5,
        },
        {
            label: Resources.PledgeManager.ComparisonLabel6,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription6,
            secondaryIcon: 'times',
        },
        {
            label: Resources.PledgeManager.ComparisonLabel7,
            primary: Resources.PledgeManager.ComparisonPrimaryDescription7,
            secondary: Resources.PledgeManager.ComparisonSecondaryDescription7,
        },
    ];
}

export function getFaqItems() {
    return [
        {
            title: Resources.PledgeManager.FaqTitle1,
            description: Resources.PledgeManager.FaqDescription1,
        },
        {
            title: Resources.PledgeManager.FaqTitle2,
            description: `<p>${Resources.PledgeManager.FaqDescription2Paragraph1}</p><p>${Resources.PledgeManager.FaqDescription2Paragraph2}</p>`,
        },
        {
            title: Resources.PledgeManager.FaqTitle3,
            description: Resources.format(Resources.PledgeManager.FaqDescription3, accentLink(Resources.PledgeManager.FaqLinkText3, Config.navigation.feesUrl)),
        },
        {
            title: Resources.PledgeManager.FaqTitle4,
            description: Resources.PledgeManager.FaqDescription4,
        },
        {
            title: Resources.PledgeManager.FaqTitle5,
            description: Resources.PledgeManager.FaqDescription5,
        },
        {
            title: Resources.PledgeManager.FaqTitle6,
            description: Resources.PledgeManager.FaqDescription6,
        },
        {
            title: Resources.PledgeManager.FaqTitle7,
            description: Resources.PledgeManager.FaqDescription7,
        },
        {
            title: Resources.PledgeManager.FaqTitle8,
            description: Resources.PledgeManager.FaqDescription8,
        },
        {
            title: Resources.PledgeManager.FaqTitle9,
            description: Resources.PledgeManager.FaqDescription9,
        },
        {
            title: Resources.PledgeManager.FaqTitle10,
            description: Resources.format(Resources.PledgeManager.FaqDescription10, accentLink(Resources.PledgeManager.FaqLinkText10, helpAdmin.howToSetUpStretchPay)),
        },
        {
            title: Resources.PledgeManager.FaqTitle11,
            description: Resources.PledgeManager.FaqDescription11,
        },
    ];
}
